var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"casual-download-header bg-grey"},[_c('h1',{style:(_vm.screenType !== 'desktop' && 'text-align: center')},[_vm._v(_vm._s(`${_vm.$t('Receive Files Securely From')} ${_vm.themeSettings.name} ${_vm.$t('by')} ${_vm.registeredName}`))])])
}
var staticRenderFns = []

export { render, staticRenderFns }